// reducers/inventoryReducer.ts

import { ISamInventory } from '@/interfaces/service/SandboxServiceManagerInterface';

// 1. Constantes de acción
export const GET_SANDBOX = 'GET_SANDBOX';
export const GET_SANDBOX_SUCCESS = 'GET_SANDBOX_SUCCESS';
export const GET_SANDBOX_ERROR = 'GET_SANDBOX_ERROR';

export const GET_SANDBOX_EXCEL = 'GET_SANDBOX_EXCEL';
export const GET_SANDBOX_EXCEL_SUCCESS = 'GET_SANDBOX_EXCEL_SUCCESS';
export const GET_SANDBOX_EXCEL_ERROR = 'GET_SANDBOX_EXCEL_ERROR';

// 2. Tipos de datos

export interface SandboxState {
  data: ISamInventory[] | null;
  loading: boolean;
  error: string | null;
  excelData: Blob | null;
  excelLoading: boolean;
  excelError: string | null;
}

// 3. Tipos de acciones
interface GetSandboxAction {
  type: typeof GET_SANDBOX;
}

interface GetSandboxSuccessAction {
  type: typeof GET_SANDBOX_SUCCESS;
  payload: ISamInventory[];
}

interface GetSandboxErrorAction {
  type: typeof GET_SANDBOX_ERROR;
  payload: string;
}

interface GetSandboxExcelAction {
  type: typeof GET_SANDBOX_EXCEL;
}

interface GetSandboxExcelSuccessAction {
  type: typeof GET_SANDBOX_EXCEL_SUCCESS;
  payload: Blob;
}

interface GetSandboxExcelErrorAction {
  type: typeof GET_SANDBOX_EXCEL_ERROR;
  payload: string;
}

type SandboxAction =
  | GetSandboxAction
  | GetSandboxSuccessAction
  | GetSandboxErrorAction
  | GetSandboxExcelAction
  | GetSandboxExcelSuccessAction
  | GetSandboxExcelErrorAction;

// 4. Estado inicial
export const initialStateGetSandbox: SandboxState = {
  data: null,
  loading: false,
  error: null,
  excelData: null,
  excelLoading: false,
  excelError: null,
};

// 5. Reducer
export const getSandbox_Red = (
  state: SandboxState = initialStateGetSandbox,
  action: SandboxAction
): SandboxState => {
  switch (action.type) {
    case GET_SANDBOX:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_SANDBOX_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case GET_SANDBOX_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_SANDBOX_EXCEL:
      return {
        ...state,
        excelLoading: true,
        excelError: null,
      };

    case GET_SANDBOX_EXCEL_SUCCESS:
      return {
        ...state,
        excelLoading: false,
        excelData: action.payload,
        excelError: null,
      };

    case GET_SANDBOX_EXCEL_ERROR:
      return {
        ...state,
        excelLoading: false,
        excelError: action.payload,
      };

    default:
      return state;
  }
};
